module.exports = __webpack_public_path__ + "img/altro1.d1c06291.png";